var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTentative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#ee404c",
    r: 45,
    id: "circle1",
    style: {
      fill: "#ffcc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.961189,25.188192 c -21.424119,0 -38.772997,17.38769 -38.772997,38.811809 0,21.424118 17.348878,38.811809 38.772997,38.811809 21.46293,0 38.850621,-17.387691 38.850621,-38.811809 0,-21.424119 -17.387691,-38.811809 -38.850621,-38.811809 m 0.03881,69.861256 c -17.15482,0 -31.049447,-13.894628 -31.049447,-31.049447 0,-17.15482 13.894627,-31.049447 31.049447,-31.049447 17.154819,0 31.049447,13.894627 31.049447,31.049447 0,17.154819 -13.894628,31.049447 -31.049447,31.049447",
    id: "path1",
    style: {
      strokeWidth: 3.88118,
      fill: "#554400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.940591,44.594096 H 60.11882 v 23.287086 l 20.3762,12.22572 2.910885,-4.773853 -17.465314,-10.362753 z",
    id: "path2",
    style: {
      strokeWidth: 3.88118,
      fill: "#554400"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentative);
export default __webpack_public_path__ + "static/media/tentative.413d02689dce6af4d5647a284e90d979.svg";
export { ForwardRef as ReactComponent };